import LoggedOut from "../layouts/loggedOut.layout";
import { useState } from "react";
import SingleCardLayout from "../layouts/singleCard.layout";

import ResetPasswordForm from "../components/forms/resetPassword.form";

const PasswordReset = () => {
  return (
    <LoggedOut>
      <SingleCardLayout>
        <ResetPasswordForm />
      </SingleCardLayout>
    </LoggedOut>
  );
};

export default PasswordReset;
